const settings = require('../../../../../js-handler/settings')
const validator = require('../../../../../components/textfield/validator.min')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const fullcontTab = require('../../../../../components/fullcont/fullcont-form-handler-tab')
const snack = require('../../../../../components/snack/snack')

let pendingPurchaseEmail = null;

function getPurchaseEmailState(htmlFc) {
  let check = htmlFc.fullcontHTML.querySelector("#purchase_send_email input");
  let inputEmail = htmlFc.fullcontHTML.querySelector("#purchase_form_email input");
  let mail = inputEmail != undefined ? inputEmail.value.trim() : "";
  let elem = document.querySelector("#purchase-fullcont");
  let dbid = elem != undefined ? elem.getAttribute("data-dbid") : null;

  return {
    checked: check != undefined ? check.checked : false,
    email: mail,
    dbid: dbid
  };
}

export function capturePurchaseEmail(htmlFc) {
  pendingPurchaseEmail = getPurchaseEmailState(htmlFc);
  return pendingPurchaseEmail;
}

export function purchaseSendEmail(detail, htmlFc, emailState = null) {
  let state = emailState || pendingPurchaseEmail || getPurchaseEmailState(htmlFc);
  pendingPurchaseEmail = null;

  let inputEmail = htmlFc.fullcontHTML.querySelector("#purchase_form_email input");
  let elem = document.querySelector("#purchase-fullcont");
  let currentDbid = elem != undefined ? elem.getAttribute("data-dbid") : null;
  let dbid = state.dbid || currentDbid;

  if (!state.checked) {
    return false;
  }

  if (!state.email || !validator.isEmail(state.email)) {
    if (inputEmail != undefined) {
      textfieldHandler.error(inputEmail.closest(".textfield"));
    }
    return false;
  }

  sendInvoicePurchase(dbid, state.email);
  return true;
}

export function sendInvoicePurchase(dbid = null, email = null) {
  if (!dbid) return;

  let input_email = document.querySelector('#purchase_form_email input');
  let userId = settings.getData().id;
  let emailValue = email != null ? email : (input_email != undefined ? input_email.value.trim() : "");

  sendmail({
    email: emailValue,
    type: "sendinvoice",
    dbid: dbid,
    userId: userId,
    entity: 'purchase'
  });
}


function sendmail(data) {
  const formData = new FormData();
  Object.keys(data).forEach(key => formData.append(key, data[key]));

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 30000);

  snack.start({ act: 'show', id: 'sendemail' });

  fetch(`./server/php/send-emails/sendEmail.php`, {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  })
    .then(res => {
      clearTimeout(timeout);
      return res.json();
    })
    .then(result => {
      if (result.code !== 200) {
        alert(result.message || "An error occurred while sending the email. Recharge");
      }
    })
    .catch(err => {
      throw err;
    });
}


export function purchaseTrackingMail(detail, htmlFc) {
  let check = htmlFc.fullcontHTML.querySelector("#purchase_send_email");
  let check_value = check.querySelector("input[type='checkbox']").checked;
  let mail = htmlFc.fullcontHTML.querySelector("#purchase_form_email input").value;
  let provider_id = "";
  let elem = document.querySelector("#purchase-fullcont");
  let dbid = elem.getAttribute("data-dbid");
  let userId = "";
  userId = settings.getData().id

  htmlFc.form.forEach((a) => {
    if (a.name == 'provider_id') {
      provider_id = a.value;
    }
  })

  if (check_value && (mail != "" && validator.isEmail(mail))) {
    trackingEmail({ purcahse_id: dbid, email: mail, provider: provider_id, entity: "purchase", user: userId });
  }
}

function trackingEmail(data) {
  const formData = new FormData();
  formData.append('purchase_id', data.purcahse_id);
  formData.append('email', data.email);
  formData.append('provider', data.provider);
  formData.append('entit', data.entity);
  formData.append('userId', data.user);
  //console.log(formData);

  const controller = new AbortController();

  // Obtén el purchase_id de alguna manera (puede ser un parámetro o una variable)
  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  fetch(`./server/php/queries/tracking/purchase_tracking_email.php`, options)
    .then(result => {
      //console.log(result)
      return result.json();
    })
    .then((result) => {
      if (result.code == 400) {
        alert("An error occurred while sending the email. Recharge");
      }
    })
    .catch((error) => {
      throw error;
      //console.log('result 3', 'ERRORRRRRRRR');
    });
}
